export default __webpack_public_path__ + "221b7aa78867ff848ba6420f693b5297.png";